import { Undo } from '@lmc/ui-kit'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'

// can't use styled/theme here, weird ant d error

const UndoButton = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation()
  return (
    <Button
      style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
      type="link"
      size="small"
      onClick={onClick}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <div style={{ marginTop: '4px' }}>
          <Undo />
        </div>
        <div style={{ fontWeight: 'bold' }}>{t('UNDO')}</div>
      </div>
    </Button>
  )
}

export default UndoButton
